<mat-card appearance="outlined" class="px-3 profile-card mb-3">
  <div>
    <div class="title">
      <img src="../../../../../assets/images/icons/icon_person.svg" />
      <h4>Your Info</h4>
    </div>
    <hr class="mt-1" />
    <div class="row">
      <div class="col-6 key-value">
        <label>NAME</label>
        <p>{{ userFullName ?? '-' }}</p>
      </div>
      <div class="col-sm-6 key-value">
        <label>EMAIL</label>
        <p>{{ email ?? '-' }}</p>
      </div>
      <div class="col-sm-6 key-value">
        <label>PHONE</label>
        <p>{{ phone ?? '-' }}</p>
      </div>
      <div class="col-12 key-value">
        <label>YOUR ACCESS</label>
        @if (hasRbacV2Roles) {
          @if (accessDataLength === 0) {
            <p>None</p>
          } @else {
            <p>{{ joinedAccessData }}</p>
          }
        } @else if (isGlobalAdmin) {
          <p>Global Admin: {{ companyEnabledServices }}</p>
        } @else {
          @if (accessDataLength === 0) {
            <p>None</p>
          } @else {
            <p>{{ joinedAccessData }}</p>
          }
        }
      </div>
    </div>
  </div>
</mat-card>
